import { createRouter, createWebHistory } from "vue-router";
import { useAuthStore } from "../store/auth.store";

const routes = [
  {
    path: "/",
    redirect: "/Login",
  },
  {
    path: "/:catchAll(.*)",
    redirect: "/Login",
  },
  {
    path: "/per",
    name: "per",
    component: () => import("../components/PersonalInformation.vue"),
  },
  {
    path: "/Login",
    name: "Login",
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/Register",
    name: "Register",
    component: () => import("../views/RegisterView.vue"),
  },
  {
    path: "/Form",
    name: "Form",
    component: () => import("../views/StepView.vue"),
  },
  {
    path: "/Form2",
    name: "Form2",
    component: () => import("../views/StepView2.vue"),
  },
  {
    path: "/test",
    name: "Test",
    component: () => import("../components/ReasonTeacherComment.vue"),
  },
  {
    path: "/progress",
    name: "Progress",
    component: () => import("../views/ProgressView.vue"),
  },
  {
    path: "/edit",
    name: "EditPersonalInfo",
    component: () => import("../views/EditPersonalInformationView.vue"),
  },
  {
    path: "/base64",
    name: "base64",
    component: () => import("../components/CovertBase64Component.vue"),
  },
  {
    path: '/editform',
    name: 'editform',
    component: () => import("../components/EditFormComponent.vue")
  },
];

const router = createRouter({
  history: createWebHistory("/thegift"),
  routes,
});

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore();
  const isAuthenticated = authStore.user !== null; // Check if user is authenticated
  const userRole = authStore.user?.role; // Assuming 'role' is a property of the user object

  // Define public routes that can be accessed without authentication
  const publicRoutes = ["Login", "Register"];

  // If the user is not authenticated and tries to access protected routes
  if (!isAuthenticated && !publicRoutes.includes(to.name)) {
    next({ name: "Login" }); // Redirect to login page
  } else {
    // Role-based access: add conditions for specific routes based on the user role
    if (
      isAuthenticated &&
      to.name === "SomeAdminPage" &&
      userRole !== "admin"
    ) {
      next({ name: "Unauthorized" }); // Redirect to an unauthorized page if the role doesn't match
    } else {
      next(); // Allow navigation to the requested route
    }
  }
});

export default router;
